
import {Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { NonFilerReferral } from '../../../types/legal/nonFilerReferral';


interface Props {
    nonFilerAGReferrals: NonFilerReferral [];
}

const NonFilerAGReferralTable = (props: Props): JSX.Element => {

        return(
                <>
                    <TableContainer>
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell><Typography variant='body2' fontWeight={550}>Date Referred</Typography></TableCell>
                                    <TableCell><Typography variant='body2' fontWeight={550}>CPF ID</Typography></TableCell>
                                    <TableCell><Typography variant='body2' fontWeight={550}>Candidate Name/Address</Typography></TableCell>
                                    <TableCell><Typography variant='body2' fontWeight={550}>Treasurer</Typography></TableCell>
                                    <TableCell><Typography variant='body2' fontWeight={550}>Missing Required Reports</Typography></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {props.nonFilerAGReferrals &&  props.nonFilerAGReferrals.map((filer: NonFilerReferral) =>
                                <TableRow key={filer.cpfId}>
                                    <TableCell>
                                        <Typography variant="body2">{filer.referralDate}</Typography>
                                    </TableCell>
                                    <TableCell><Link href={`/filers?q=${filer.cpfId}`} target="_blank" underline='none'>{filer.cpfId}</Link></TableCell>
                                    <TableCell>
                                        <Typography variant="body2"> 
                                            {filer.candidateName}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary"><i>{filer.candidateStreetAddress} {filer.candidateCity} {filer.candidateState} {filer.candidateZipCode}</i></Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">{filer.treasurerName}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        {filer.expectedReports && filer.expectedReports.map((report, index) => (
                                            <Typography key={index} variant="body2">{report.reportYear} {report.reportTypeDescription}</Typography>
                                        ))}
                                    </TableCell>
                                </TableRow>
                        )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
     )

}

export default NonFilerAGReferralTable;